import { createSelector } from 'reselect';
//import { CareersReduxType, CareersSelectorType } from '../types';

const team = (state: { teamReducer: { team: any } }) =>
    state.teamReducer.team;

export const teamSelector = createSelector([team], item => {
    let data: {
        title: string,
        description: string,
        teamTitle: string,
        teamList: [],
        bottomInfo: {},
    } = {
        title: "",
        description: "",
        teamTitle: "",
        teamList: [],
        bottomInfo: {},
    };
    if (item) {
        const { attributes } = item;
        data = {
            title: attributes.Title,
            description: attributes.Description,
            teamTitle: attributes.TeamTitle,
            teamList: attributes.OurTeam,
            bottomInfo: attributes.BottomInfo,
        };
    }
    return data;
});
